// Libs
import { createAsyncThunk } from '@reduxjs/toolkit';
// Others
import { CREATE_PAYMENT, GET_PAYMENT_LIST } from '~/utils/constants/actionType';
import paymentApi from '~/apis/payment';
import { IQueryParamPayment } from '~/utils/interface/payment';
import { IPaymentQuote } from '~/utils/interface/quotes';

export const getPaymentList = createAsyncThunk(
  GET_PAYMENT_LIST,
  async (params: IQueryParamPayment, { rejectWithValue }) => {
    try {
      const resp = await paymentApi.getListPayment(params);
      return resp.data;
    } catch (error) {
      return rejectWithValue(error);
    }
  }
);

export const createPayment = createAsyncThunk(CREATE_PAYMENT, async (body: IPaymentQuote, { rejectWithValue }) => {
  try {
    const resp = await paymentApi.createPayment(body);
    return resp.data;
  } catch (error) {
    return rejectWithValue(error);
  }
});
